export default class Tools {

    static getCleanURL(){
        return location.protocol+'//'+location.host+location.pathname;
    }
    
    // Cookies Support
    //
    // Source: https://www.quirksmode.org/js/cookies.html
    
    static writeCookie(aName,aValue,aDays){

        let expires = "";
        if (aDays) {
            let date = new Date();
            date.setTime(date.getTime()+(aDays*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        } 
        document.cookie = aName+"="+aValue+expires+"; path=/";
    }
    
    static readCookie(aName){
        let nameEQ = aName + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    static removeCookie(aName){
        Tools.writeCookie(aName,"",-1);
    }

    static isTouch(){
        return ('ontouchstart' in window);
    }
    
}